class Pagination {
  constructor() {
    this.fireMobilePaginationClickEvent = this.fireMobilePaginationClickEvent.bind(
      this
    );
    this.fireViewCountChangeEvent = this.fireViewCountChangeEvent.bind(this);
    $(document).on(
      'click',
      '.pc-Pagination-kaminari a',
      this.fireMobilePaginationClickEvent
    );
    $(document).on(
      'click',
      '.pc-Pagination-updateView',
      this.fireViewCountChangeEvent
    );
    this.initBehavior();
  }

  initBehavior() {
    enquire.register(StyleBitz.Layouts.sm, () =>
      this.toggleLastRowProductCards('sm')
    );
    enquire.register(StyleBitz.Layouts.md, () =>
      this.toggleLastRowProductCards('md')
    );
    enquire.register(StyleBitz.Layouts.lg, () =>
      this.toggleLastRowProductCards('lg')
    );
    return enquire.register(StyleBitz.Layouts.xl, () =>
      this.toggleLastRowProductCards('xl')
    );
  }

  toggleLastRowProductCards(breakpoint) {
    if (!$('.pc-Styles-products').hasClass('is-promoCardShown')) {
      return;
    }
    const totalProductCount = parseInt($('.pc-Styles-count').text(), 10);
    if (!(totalProductCount > $('.pc-ProductCard').length)) {
      return;
    }
    const lastProductCard = $('.pc-ProductCard').last();
    if (breakpoint === 'lg') {
      return lastProductCard.hide();
    } else {
      return lastProductCard.show();
    }
  }

  fireMobilePaginationClickEvent(e) {
    const el = $(e.currentTarget);
    const parsedTargetHref = el.attr('href').match(/page=([^&]+)/);
    let value = 1;
    if (parsedTargetHref) {
      value = parsedTargetHref[1];
    }
    return CustomInk.Metrics.fireEvent('listing pagination', 'see more', value);
  }

  fireViewCountChangeEvent(e) {
    const el = $(e.currentTarget);
    let value = 'view all';
    if (el.text() === 'View As Pages') {
      value = 'view as pages';
    }
    return CustomInk.Metrics.fireEvent('listing pagination', value);
  }
}

jQuery(() => (ProductCatalog.Pagination = new Pagination()));
